import { Request } from '@/classes/Request.ts'

/**
 * Authenticates user using PowerSchool SSO token
 *
 * This function is used specifically for PowerSchool iframe-based authentication.
 * When the PowerSchool parent window sends an AUTH_TOKEN via postMessage,
 * this function sends that token to the backend's /ajax/ps_token_login endpoint
 * to establish the user session with HttpOnly cookies.
 *
 * @param token - PowerSchool authentication token received from parent iframe
 * @returns Promise that resolves on successful authentication or rejects with error message
 *
 * Used by: PowerschoolLandingView.vue
 */
export const loginWithToken = async (token: string): Promise<void | string> => {
  return new Promise((resolve, reject) => {
    new Request()
      .post('/ajax/ps_token_login', { token })
      .then(() => {
        resolve()
      })
      .catch((err: any) => {
        if (err.response.status === 400) {
          reject('Log-in failed, invalid token')
        }
        if (err.response.status === 401) {
          reject('Log-in failed, token expired or invalid')
        }
        if (err.response.status === 429) {
          reject('Log-in failed, please wait and try again later')
        }
        if (err.response.status === 500) {
          reject('Log-in failed, server error')
        }
        reject('Log-in failed, unknown reason')
      })
  })
}
